import request from '@/plugins/axios'

/** S 钻石供应商 **/
// 供应商列表
/**
 * 获取供应商列表数据
 * @param params - 查询参数对象
 * @returns 返回请求响应结果
 */
export const apiSupplierList = (params: any) => request.get('/sync.sync/diamondSupplierLists', {params})
/**
 * 更新供应商信息的API接口函数
 * @param params - 包含供应商更新信息的参数对象，类型为any
 * @returns 返回一个Promise，通过request.post方法发送POST请求到指定接口
 */
export const apiSupplierUpdate = (params: any) => request.post('/sync.sync/diamondSupplierUpdate', {...params})

/**
 * 搜索供应商信息的API函数
 * @param params - 查询参数对象，包含搜索条件
 * @returns 返回一个Promise对象，包含供应商信息的查询结果
 */
export const apiSupplierSearch = (params?: any) => request.get('/sync.sync/diamondSupplierEnumInfo', {params})

/**
 * 获取钻石API账户列表
 * @param params - 请求参数，类型为any
 * @returns 返回一个请求对象，使用request.get方法发送GET请求到'/sync.sync/diamondApiAccountLists'端点
 */
export const apiDiamonApiList = (params: any) => request.get('/sync.sync/diamondApiAccountLists', {params})
export const apiDiamondApiUpdate = (params: any) => request.post('/sync.sync/diamondApiAccountSave', {...params})

